export const ERECRUITMENT = `ERECRUITMENT`;

/* LAYOUT */
export const GET_SEARCH_PRE_CANDIDATE_PENDING_DATA = `${ERECRUITMENT}/GET_SEARCH_PRE_CANDIDATE_PENDING_DATA`;
export const SET_SEARCH_PRE_CANDIDATE_PENDING_DATA = `${ERECRUITMENT}/SET_SEARCH_PRE_CANDIDATE_PENDING_DATA`;

export const GET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA = `${ERECRUITMENT}/GET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA`;
export const SET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA = `${ERECRUITMENT}/SET_SEARCH_PRE_CANDIDATE_PROCESSED_DATA`;

export const GET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA = `${ERECRUITMENT}/GET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA`;
export const SET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA = `${ERECRUITMENT}/SET_AD_SEARCH_PRE_CANDIDATE_PENDING_DATA`;

export const GET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA = `${ERECRUITMENT}/GET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA`;
export const SET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA = `${ERECRUITMENT}/SET_AD_SEARCH_PRE_CANDIDATE_PROCESSED_DATA`;

export const GET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA = `${ERECRUITMENT}/GET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA`;
export const SET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA = `${ERECRUITMENT}/SET_AD_SEARCH_PRE_CANDIDATE_COURSE_DATA`;
export const GET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA = `${ERECRUITMENT}/GET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA`;
export const GET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA = `${ERECRUITMENT}/GET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA`;
export const SET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA = `${ERECRUITMENT}/SET_AD_SEARCH_INFO_CANDIDATE_COURSE_DATA`;
export const SET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA = `${ERECRUITMENT}/SET_AD_SEARCH_CLASS_CANDIDATE_COURSE_DATA`;

export const GET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA = `${ERECRUITMENT}/GET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA`;
export const SET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA = `${ERECRUITMENT}/SET_AOS_SEARCH_PRE_CANDIDATE_PENDING_DATA`;

export const GET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA = `${ERECRUITMENT}/GET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA`;
export const SET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA = `${ERECRUITMENT}/SET_AOS_SEARCH_PRE_CANDIDATE_PROCESSED_DATA`;

export const GET_LIST_OF_VALUE_DATA = `${ERECRUITMENT}/GET_LIST_OF_VALUE_DATA`;
export const SET_LIST_OF_VALUE_DATA = `${ERECRUITMENT}/SET_LIST_OF_VALUE_DATA`;

export const GET_TITLE_FOR_NOUS_DATA = `${ERECRUITMENT}/GET_TITLE_FOR_NOUS_DATA`;
export const SET_TITLE_FOR_NOUS_DATA = `${ERECRUITMENT}/SET_TITLE_FOR_NOUS_DATA`;

export const SET_CONFIG_FILTER = `${ERECRUITMENT}/SET_CONFIG_FILTER`;
export const SET_AD_CONFIG_FILTER = `${ERECRUITMENT}/SET_AD_CONFIG_FILTER`;
export const SET_AOS_CONFIG_FILTER = `${ERECRUITMENT}/SET_AOS_CONFIG_FILTER`;

export const GET_STATUS_DATA = `${ERECRUITMENT}/GET_STATUS_DATA`;
export const SET_STATUS_DATA = `${ERECRUITMENT}/SET_STATUS_DATA`;

export const GET_ALL_AD_DATA = `${ERECRUITMENT}/GET_ALL_AD_DATA`;
export const SET_ALL_AD_DATA = `${ERECRUITMENT}/SET_ALL_AD_DATA`;

export const GET_ALL_AM_DATA = `${ERECRUITMENT}/GET_ALL_AM_DATA`;
export const SET_ALL_AM_DATA = `${ERECRUITMENT}/SET_ALL_AM_DATA`;

export const GET_LIST_TRAINING_CLASS_DATA = `${ERECRUITMENT}/GET_LIST_TRAINING_CLASS_DATA`;
export const SET_LIST_TRAINING_CLASS_DATA = `${ERECRUITMENT}/SET_LIST_TRAINING_CLASS_DATA`;

export const GET_PROVINCES_DATA = `${ERECRUITMENT}/GET_PROVINCES_DATA`;
export const SET_PROVINCES_DATA = `${ERECRUITMENT}/SET_PROVINCES_DATA`;

export const GET_DISTRICTS_DATA = `${ERECRUITMENT}/GET_DISTRICTS_DATA`;
export const SET_DISTRICTS_DATA = `${ERECRUITMENT}/SET_DISTRICTS_DATA`;

export const GET_WARDS_DATA = `${ERECRUITMENT}/GET_WARDS_DATA`;
export const GET_WARDS_2_LEVEL_DATA = `${ERECRUITMENT}/GET_WARDS_2_LEVEL_DATA`;
export const SET_WARDS_DATA = `${ERECRUITMENT}/SET_WARDS_DATA`;

export const GET_LIST_OFFICE_DATA = `${ERECRUITMENT}/GET_LIST_OFFICE_DATA`;
export const SET_LIST_OFFICE_DATA = `${ERECRUITMENT}/SET_LIST_OFFICE_DATA`;

export const REGISTER_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/REGISTER_BY_RECRUITER_REQUEST`;
export const REGISTER_BY_RECRUITER_SUCCESS = `${ERECRUITMENT}/REGISTER_BY_RECRUITER_SUCCESS`;

export const UPDATE_EMAIL_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/UPDATE_EMAIL_BY_RECRUITER_REQUEST`;

export const CHECK_DUPLICATED_PHONE_REQUEST = `${ERECRUITMENT}/CHECK_DUPLICATED_PHONE_REQUEST`;
export const CHECK_DUPLICATED_PHONE_SUCCESS = `${ERECRUITMENT}/CHECK_DUPLICATED_PHONE_SUCCESS`;

export const CREATE_POST_PRESIGNED_REQUEST = `${ERECRUITMENT}/CREATE_POST_PRESIGNED_REQUEST`;
export const CREATE_POST_PRESIGNED_SUCCESS = `${ERECRUITMENT}/CREATE_POST_PRESIGNED_SUCCESS`;

export const POST_FILE_REQUEST = `${ERECRUITMENT}/POST_FILE_REQUEST`;
export const POST_FILE_SUCCESS = `${ERECRUITMENT}/POST_FILE_SUCCESS`;

export const GET_TRACKING_REQUEST = `${ERECRUITMENT}/GET_TRACKING_REQUEST`;
export const GET_TRACKING_SUCCESS = `${ERECRUITMENT}/GET_TRACKING_SUCCESS`;

export const GET_FILES_DATA = `${ERECRUITMENT}/GET_FILES_DATA`;
export const SET_FILES_DATA = `${ERECRUITMENT}/SET_FILES_DATA`;

export const UPDATE_BY_PRE_CANDIDATE_REQUEST = `${ERECRUITMENT}/UPDATE_BY_PRE_CANDIDATE_REQUEST`;
export const UPDATE_BY_PRE_CANDIDATE_SUCCESS = `${ERECRUITMENT}/UPDATE_BY_PRE_CANDIDATE_SUCCESS`;

export const CHECK_STEP_CANDIDATE_REQUEST = `${ERECRUITMENT}/CHECK_STEP_CANDIDATE_REQUEST`;
export const CHECK_STEP_CANDIDATE_SUCCESS = `${ERECRUITMENT}/CHECK_STEP_CANDIDATE_SUCCESS`;

export const GET_KAPTCHA_DATA = `${ERECRUITMENT}/GET_KAPTCHA_DATA`;
export const SET_KAPTCHA_DATA = `${ERECRUITMENT}/SET_KAPTCHA_DATA`;

export const GENERATE_OTP_REQUEST = `${ERECRUITMENT}/GENERATE_OTP_REQUEST`;
export const GENERATE_OTP_SUCCESS = `${ERECRUITMENT}/GENERATE_OTP_SUCCESS`;

export const RELOAD_OTP_REQUEST = `${ERECRUITMENT}/RELOAD_OTP_REQUEST`;
export const RELOAD_OTP_SUCCESS = `${ERECRUITMENT}/RELOAD_OTP_SUCCESS`;

export const VERIFY_OTP_REQUEST = `${ERECRUITMENT}/VERIFY_OTP_REQUEST`;
export const VERIFY_OTP_SUCCESS = `${ERECRUITMENT}/VERIFY_OTP_SUCCESS`;

export const GET_CHECK_APPLICATION_STATUS_REQUEST = `${ERECRUITMENT}/GET_CHECK_APPLICATION_STATUS_REQUEST`;
export const GET_CHECK_APPLICATION_STATUS_SUCCESS = `${ERECRUITMENT}/GET_CHECK_APPLICATION_STATUS_SUCCESS`;

export const GET_ERE_DETAIL_REQUEST = `${ERECRUITMENT}/GET_ERE_DETAIL_REQUEST`;
export const GET_ERE_DETAIL_SUCCESS = `${ERECRUITMENT}/GET_ERE_DETAIL_SUCCESS`;

// DETAIL
export const GET_PRE_CANDIDATE_DETAIL_DATA = `${ERECRUITMENT}/GET_PRE_CANDIDATE_DETAIL_DATA`;
export const SET_PRE_CANDIDATE_DETAIL_DATA = `${ERECRUITMENT}/SET_PRE_CANDIDATE_DETAIL_DATA`;

export const GET_EAPP_PROCESS_HISTORY_DATA = `${ERECRUITMENT}/GET_EAPP_PROCESS_HISTORY_DATA`;
export const SET_EAPP_PROCESS_HISTORY_DATA = `${ERECRUITMENT}/SET_EAPP_PROCESS_HISTORY_DATA`;

export const GET_DOC_BUFFERED_DATA = `${ERECRUITMENT}/GET_DOC_BUFFERED_DATA`;

export const CANDIDATE_CANCEL_E_APP_REQUEST = `${ERECRUITMENT}/CANDIDATE_CANCEL_E_APP_REQUEST`;

export const UPDATE_BY_AM_REQUEST = `${ERECRUITMENT}/UPDATE_BY_AM_REQUEST`;

export const SAVE_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/SAVE_BY_RECRUITER_REQUEST`;

export const SUBMIT_CHANGE_COURSE_REQUEST = `${ERECRUITMENT}/SUBMIT_CHANGE_COURSE_REQUEST`;
export const VALIDATE_CANDIDATE_INFO_CHANGE_COURSE_REQUEST = `${ERECRUITMENT}/VALIDATE_CANDIDATE_INFO_CHANGE_COURSE_REQUEST`;

export const RECRUITER_CANCEL_E_APP_REQUEST = `${ERECRUITMENT}/RECRUITER_CANCEL_E_APP_REQUEST`;

export const DOWNLOAD_BY_CANDIDATE_REQUEST = `${ERECRUITMENT}/DOWNLOAD_BY_CANDIDATE_REQUEST`;

export const GET_ASCORE_REQUEST = `${ERECRUITMENT}/GET_ASCORE_REQUEST`;
export const GET_ASCORE_SUCCESS = `${ERECRUITMENT}/GET_ASCORE_SUCCESS`;

export const UPDATE_BY_AD_REQUEST = `${ERECRUITMENT}/UPDATE_BY_AD_REQUEST`;

export const UPDATE_BY_AOS_REQUEST = `${ERECRUITMENT}/UPDATE_BY_AOS_REQUEST`;
export const AGENCY_SAVE_BY_CANDIDATE_REQUEST = `${ERECRUITMENT}/AGENCY_SAVE_BY_CANDIDATE_REQUEST`;
export const CHECK_ID_NUMBER_IN_AGIS_REQUEST = `${ERECRUITMENT}/CHECK_ID_NUMBER_IN_AGIS`;
export const CHECK_AD_SUBMIT_WARNING_REQUEST = `${ERECRUITMENT}/CHECK_AD_SUBMIT_WARNING`;

// NOUS

export const NOUS_REGISTER_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/NOUS_REGISTER_BY_RECRUITER_REQUEST`;

export const NOUS_UPDATE_EMAIL_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/NOUS_UPDATE_EMAIL_BY_RECRUITER_REQUEST`;

export const NOUS_SAVE_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/NOUS_SAVE_BY_RECRUITER_REQUEST`;

export const NOUS_RECRUITER_CANCEL_E_APP_REQUEST = `${ERECRUITMENT}/NOUS_RECRUITER_CANCEL_E_APP_REQUEST`;

export const NOUS_UPDATE_BY_PRE_CANDIDATE_REQUEST = `${ERECRUITMENT}/NOUS_UPDATE_BY_PRE_CANDIDATE_REQUEST`;

export const NOUS_CANDIDATE_CANCEL_E_APP_REQUEST = `${ERECRUITMENT}/NOUS_CANDIDATE_CANCEL_E_APP_REQUEST`;

export const NOUS_GET_PRE_CANDIDATE_DETAIL_DATA = `${ERECRUITMENT}/NOUS_GET_PRE_CANDIDATE_DETAIL_DATA`;
export const NOUS_SET_PRE_CANDIDATE_DETAIL_DATA = `${ERECRUITMENT}/NOUS_SET_PRE_CANDIDATE_DETAIL_DATA`;

export const FTA_CHECK_STEP_CANDIDATE_REQUEST = `${ERECRUITMENT}/FTA_CHECK_STEP_CANDIDATE_REQUEST`;

export const FTA_GENERATE_OTP_REQUEST = `${ERECRUITMENT}/FTA_GENERATE_OTP_REQUEST`;

export const FTA_RELOAD_OTP_REQUEST = `${ERECRUITMENT}/FTA_RELOAD_OTP_REQUEST`;

export const FTA_VERIFY_OTP_REQUEST = `${ERECRUITMENT}/FTA_VERIFY_OTP_REQUEST`;

export const NOUS_UPDATE_BY_AM_REQUEST = `${ERECRUITMENT}/NOUS_UPDATE_BY_AM_REQUEST`;

export const NOUS_GET_ASCORE_REQUEST = `${ERECRUITMENT}/NOUS_GET_ASCORE_REQUEST`;
export const NOUS_GET_ASCORE_SUCCESS = `${ERECRUITMENT}/NOUS_GET_ASCORE_SUCCESS`;

export const NOUS_UPDATE_BY_AD_REQUEST = `${ERECRUITMENT}/NOUS_UPDATE_BY_AD_REQUEST`;

export const NOUS_UPDATE_BY_AOS_REQUEST = `${ERECRUITMENT}/NOUS_UPDATE_BY_AOS_REQUEST`;
export const NOUS_SAVE_BY_CANDIDATE_REQUEST = `${ERECRUITMENT}/NOUS_SAVE_BY_CANDIDATE_REQUEST`;

// FLAIR
export const FLAIR_VALIDATE_CANDIDATE_REQUEST = `${ERECRUITMENT}/FLAIR_VALIDATE_CANDIDATE_REQUEST`;
export const FLAIR_SAVE_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/FLAIR_SAVE_BY_RECRUITER_REQUEST`;
export const FLAIR_GET_PRE_CANDIDATE_DETAIL_DATA = `${ERECRUITMENT}/FLAIR_GET_PRE_CANDIDATE_DETAIL_DATA`;
export const FLAIR_SET_PRE_CANDIDATE_DETAIL_DATA = `${ERECRUITMENT}/FLAIR_SET_PRE_CANDIDATE_DETAIL_DATA`;
export const FLAIR_RECRUITER_CANCEL_E_APP_REQUEST = `${ERECRUITMENT}/FLAIR_RECRUITER_CANCEL_E_APP_REQUEST`;
export const FLAIR_SET_BANK_OFFICE_DATA = `${ERECRUITMENT}/FLAIR_SET_BANK_OFFICE_DATA`;
export const FLAIR_SET_TEAM_OFFICE_DATA = `${ERECRUITMENT}/FLAIR_SET_TEAM_OFFICE_DATA`;
export const FLAIR_SET_AM_TEAM_DATA = `${ERECRUITMENT}/FLAIR_SET_AM_TEAM_DATA`;
export const FLAIR_SET_AD_TEAM_DATA = `${ERECRUITMENT}/FLAIR_SET_AD_TEAM_DATA`;

export const FLAIR_REGISTER_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/FLAIR_REGISTER_BY_RECRUITER_REQUEST`;
export const SET_ERECRUITMENT_PRE_CANDIDATE_ID = `${ERECRUITMENT}/SET_ERECRUITMENT_PRE_CANDIDATE_ID`;
export const FLAIR_SAVE_BY_CANDIDATE_REQUEST = `${ERECRUITMENT}/FLAIR_SAVE_BY_CANDIDATE_REQUEST`;
export const FLAIR_UPDATE_BY_PRE_CANDIDATE_REQUEST = `${ERECRUITMENT}/FLAIR_UPDATE_BY_PRE_CANDIDATE_REQUEST`;
export const FLAIR_CANCEL_BY_PRE_CANDIDATE_REQUEST = `${ERECRUITMENT}/FLAIR_CANCEL_BY_PRE_CANDIDATE_REQUEST`;
export const FLAIR_RE_SUBMIT_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/FLAIR_RE_SUBMIT_BY_RECRUITER_REQUEST`;
export const FLAIR_UPDATE_BY_AD_REQUEST = `${ERECRUITMENT}/FLAIR_UPDATE_BY_AD_REQUEST`;
export const FLAIR_PICK_UP_BY_AOS = `${ERECRUITMENT}/FLAIR_PICK_UP_BY_AOS`;
export const FLAIR_UPDATE_BY_AOS_REQUEST = `${ERECRUITMENT}/FLAIR_UPDATE_BY_AOS_REQUEST`;
export const FLAIR_SAVE_BY_AOS_REQUEST = `${ERECRUITMENT}/FLAIR_SAVE_BY_AOS_REQUEST`;

// DELASOL
export const DELASOL_SAVE_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/DELASOL_SAVE_BY_RECRUITER_REQUEST`;
export const DELASOL_REGISTER_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/DELASOL_REGISTER_BY_RECRUITER_REQUEST`;
export const DELASOL_RECRUITER_CANCEL_E_APP_REQUEST = `${ERECRUITMENT}/DELASOL_RECRUITER_CANCEL_E_APP_REQUEST`;
export const DELASOL_VALIDATE_CANDIDATE_REQUEST = `${ERECRUITMENT}/DELASOL_VALIDATE_CANDIDATE_REQUEST`;
export const DELASOL_UPDATE_EMAIL_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/DELASOL_UPDATE_EMAIL_BY_RECRUITER_REQUEST`;
export const DELASOL_CLONE_E_APP_REQUEST = `${ERECRUITMENT}/DELASOL_CLONE_E_APP_REQUEST`;
export const CLONE_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/CLONE_BY_RECRUITER_REQUEST`;
export const CLONE_BY_RECRUITER_REQUEST_FTA = `${ERECRUITMENT}/CLONE_BY_RECRUITER_REQUEST_FTA`;
export const SET_ERECRUITMENT_PRE_CANDIDATE_CHANNEL_CODE = `${ERECRUITMENT}/SET_ERECRUITMENT_PRE_CANDIDATE_CHANNEL_CODE`;
export const DELASOL_SAVE_BY_CANDIDATE_REQUEST = `${ERECRUITMENT}/DELASOL_SAVE_BY_CANDIDATE_REQUEST`;
export const DELASOL_CANCEL_BY_CANDIDATE_REQUEST = `${ERECRUITMENT}/DELASOL_CANCEL_BY_CANDIDATE_REQUEST`;
export const DELASOL_UPDATE_BY_APP1_REQUEST = `${ERECRUITMENT}/DELASOL_UPDATE_BY_APP1_REQUEST`;
export const DELASOL_RE_SUBMIT_BY_RECRUITER_REQUEST = `${ERECRUITMENT}/DELASOL_RE_SUBMIT_BY_RECRUITER_REQUEST`;
export const DELASOL_UPDATE_BY_PRE_CANDIDATE_REQUEST = `${ERECRUITMENT}/DELASOL_SUBMIT_BY_CANDIDATE_REQUEST`;
export const DELASOL_UPDATE_BY_APP2_REQUEST = `${ERECRUITMENT}/DELASOL_UPDATE_BY_APP2_REQUEST`;
export const DELASOL_SAVE_BY_AOS_REQUEST = `${ERECRUITMENT}/DELASOL_SAVE_BY_AOS_REQUEST`;
export const DELASOL_UPDATE_BY_AOS_REQUEST = `${ERECRUITMENT}/DELASOL_UPDATE_BY_AOS_REQUEST`;
export const GET_EAPP_PROCESS_HISTORY_DATA_V2 = `${ERECRUITMENT}/GET_EAPP_PROCESS_HISTORY_DATA_V2`;
export const SET_EAPP_PROCESS_HISTORY_DATA_V2 = `${ERECRUITMENT}/SET_EAPP_PROCESS_HISTORY_DATA_V2`;
